module.exports = __webpack_public_path__ + "static/media/close-x-icon.5a7376a9.svg";